import React from 'react';
import ContactDetailsPage from '../components/ContactDetailsPage';

const ContactDetailsApp = (props) => (
  <ContactDetailsPage {...props} />
);

export default ContactDetailsApp;